export const getImageDimensionsFromUrl = (url) => {
  return new Promise((resolve) => {
    var img = new Image();

    img.onload = function () {
      const height = img.height;
      const width = img.width;
      resolve({ img, height, width });
    };

    img.src = url;
  });
};
